import { HStack, VStack, Text, Box } from '@chakra-ui/react';
import { ChatIcon, EditBlackIcon } from '@halo/ui-chat-react';
import { useNavigate } from 'react-router';
import { useAppStore } from '@halo/chat-sdk-react';
import type { User } from '@halo/chat-sdk-react';
import { useActionsStore } from '@/store/actions';
import Paths from '@/configs/router/paths';

const SelfActions = ({ user }: { user: User }) => {
  const { t } = useTranslation();
  const { setProfileEdit, setProfileOpen } = useActionsStore();
  const navigate = useNavigate();
  const { createSingleSession } = useAppStore();
  const navData = [
    {
      key: 'Edit',
      icon: <EditBlackIcon />,
      text: t('buttons.edit'),
      // variant: 'solid',
      onclick: () => {
        setProfileOpen(false, false);
        setProfileEdit(true);
      },
    },
    {
      key: 'Chat',
      icon: <ChatIcon />,
      text: t('profile.chat'),
      // variant: 'outline',
      onclick: async () => {
        const session = await createSingleSession(user.user_id);
        navigate(Paths.MESSAGES_CHATS + '/' + session?.chat_id);
        setProfileOpen(false);
      },
    },
  ];

  return (
    <HStack w="full" px="0" gap="2.5" pt="2">
      {navData.map((item) => {
        const Item = (
          <>
            <Box>{item.icon}</Box>
            <Text fontSize="md" fontWeight="semibold">
              {item.text}
            </Text>
          </>
        );
        return (
          <VStack
            bg="bg"
            flex={1}
            rounded="xl"
            py="4"
            alignItems="center"
            gap="1"
            key={item.key}
            onClick={item?.onclick}
            cursor="pointer"
          >
            {Item}
          </VStack>
        );
      })}
    </HStack>
  );
};

export default SelfActions;
